export * from "./PageAgreement";
